export const blockIconsCommunicationCoPresentNew = (
	<span className='material-symbols-outlined'>co_present</span>
);
